var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.644,
    height: 13.469,
    viewBox: "0 0 12.644 13.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(-243.649 -243.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M253.117,244.829c-.07-.032-.117-.052-.163-.075a6.28,6.28,0,0,0-4.116-.6,6.354,6.354,0,1,0,7.415,7.477,1.6,1.6,0,0,0,.019-.605.717.717,0,0,0-.747-.54.748.748,0,0,0-.7.664,4.863,4.863,0,1,1-2.581-5.063c.048.026.094.056.169.1-.348.06-.66.1-.968.17a.746.746,0,1,0,.287,1.464l2.539-.433a.747.747,0,0,0,.656-.893c-.14-.853-.289-1.7-.441-2.555a.743.743,0,0,0-.865-.649.76.76,0,0,0-.6.933C253.05,244.417,253.081,244.612,253.117,244.829Z",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M253.117,244.829c-.036-.217-.067-.412-.1-.606a.76.76,0,0,1,.6-.933.743.743,0,0,1,.865.649c.152.851.3,1.7.441,2.555a.747.747,0,0,1-.656.893l-2.539.433a.746.746,0,1,1-.287-1.464c.308-.065.62-.11.968-.17-.075-.046-.121-.076-.169-.1a4.855,4.855,0,1,0,2.581,5.063.748.748,0,0,1,.7-.664.717.717,0,0,1,.747.54,1.6,1.6,0,0,1-.019.605,6.359,6.359,0,1,1-7.415-7.477,6.28,6.28,0,0,1,4.116.6C253,244.777,253.047,244.8,253.117,244.829Z",
    fill: "#8e8e8e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5a2e95de1e4256c2ba640a6a690a4c5e.svg";
export { ForwardRef as ReactComponent };